import React from 'react';
import type { ForkEffect } from 'redux-saga/effects';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import type { IPromptToastAction } from '../actions';
import { TOAST_PROMPT, requireToastContainer } from '../actions';

import Message from '../components/message';

declare global {
  interface Window {
    registerSaga: (saga: () => Generator<ForkEffect, void, unknown>) => void;
  }
}

const loadAndDisplayToast = async (action: IPromptToastAction) => {
  const { toast } = await import(
    /* webpackChunkName: "toast" */ 'react-toastify'
  );

  return toast[action.promptType](
    <Message type={action.promptType}>{action.content}</Message>,
    action.options
  );
};

function* handleToastAction(action: IPromptToastAction): any {
  const toastContainerLoaded = yield select(state => state.toast.required);

  if (!toastContainerLoaded) {
    yield put(requireToastContainer());
  }

  yield call(loadAndDisplayToast, action);
}

function* toastSaga() {
  yield takeEvery(TOAST_PROMPT, handleToastAction);
}

if (IS_BROWSER && window && window.registerSaga) {
  window.registerSaga(toastSaga);
}

export default toastSaga;
